// extracted by mini-css-extract-plugin
export default {"component":"PaginationButtons_component__4mAcN","text":"PaginationButtons_text__IWPET","button":"PaginationButtons_button__KBUOq"};